module.exports = __webpack_public_path__ + "img/touxiang (1).d55d9018.png";